// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2icRI","modalForm":"UpgradeEpcsModal_modalForm__2DYZ_","modalFooter":"UpgradeEpcsModal_modalFooter__1f19H"};